// EN | MT segmented control.

import type { ManifestoLanguage } from '../../lib/useManifestoQuery';
import './LanguageToggle.css';

const LANGS: Array<{ code: ManifestoLanguage; label: string }> = [
  { code: 'en', label: 'EN' },
  { code: 'mt', label: 'MT' },
];

export default function LanguageToggle({
  value,
  onChange,
}: {
  value: ManifestoLanguage;
  onChange: (l: ManifestoLanguage) => void;
}) {
  return (
    <div className="mf-lang" role="group" aria-label="Language">
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          className={`mf-lang__btn${value === l.code ? ' is-active' : ''}`}
          aria-pressed={value === l.code}
          onClick={() => onChange(l.code)}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
